import { render } from "./AddressAutocomplete.vue?vue&type=template&id=c0f67dcc&ts=true"
import script from "./AddressAutocomplete.vue?vue&type=script&lang=ts"
export * from "./AddressAutocomplete.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__